import { RootState } from '../../types';

export const all = (state: RootState) => state.games.favorites;
export const list = (state: RootState) => all(state).list;
export const loading = (state: RootState) => all(state).loading;
